export default __webpack_public_path__ + "static/media/search_empty.db764351.svg";